import React from "react"
import { KeyIcon } from "@heroicons/react/24/outline"

/**
 * Display component showing user credentials count with click to view
 */
const UserCredentials = ({ user, onViewCredentials }) => {
  const credentials = [
    { key: "Google ID", value: user.google_id },
    { key: "Apple ID", value: user.apple_id },
    { key: "Facebook ID", value: user.facebook_id },
    { key: "Internal ID", value: user.internal_id },
    { key: "Stripe Customer", value: user.stripe_customer_id },
  ].filter(cred => cred.value)

  if (credentials.length === 0) {
    return <span className="text-admin_text_secondary text-sm">None</span>
  }

  return (
    <button
      className="flex items-center gap-1 text-admin_primary hover:text-admin_primary/80 whitespace-nowrap transition-colors"
      onClick={() => onViewCredentials(user)}
    >
      <KeyIcon className="hidden xl:block w-4 h-4" />
      {credentials.length} credential{credentials.length > 1 ? 's' : ''}
    </button>
  )
}

export default UserCredentials
